import React, { forwardRef } from 'react'
import Editor from 'draft-js-plugins-editor'
import createInlineToolbarPlugin from 'draft-js-inline-toolbar-plugin'
import createLinkPlugin from 'draft-js-anchor-plugin'
import {
  BoldButton,
  ItalicButton,
  OrderedListButton,
  UnorderedListButton
} from 'draft-js-buttons'
import styled from 'styled-components'

const linkPlugin = createLinkPlugin({
  placeholder: 'Enter a link URL',
  linkTarget: '_blank'
})

const inlineToolbarPlugin = createInlineToolbarPlugin({
  structure: [
    BoldButton,
    ItalicButton,
    UnorderedListButton,
    OrderedListButton,
    linkPlugin.LinkButton
  ]
})
const { InlineToolbar } = inlineToolbarPlugin
const plugins = [inlineToolbarPlugin, linkPlugin]

// https://github.com/draft-js-plugins/draft-js-plugins/pull/1018
export const InlineToolbarWrapper = styled.div`
  white-space: nowrap;
`

const EditorStyles = styled.div`
  .draftJsToolbar__toolbar__dNtBH {
    @media only screen and (max-device-width: 1024px) {
      margin-left: 26px;
      padding: 20px 0;
      background-color: #fbfbfb;
    }
  }
  .draftJsToolbar__buttonWrapper__1Dmqh {
    //style the button wrapper
  }
  .draftJsToolbar__button__qi1gf {
    @media only screen and (max-device-width: 1024px) {
      padding: 5px 0 0 0 !important;
    }
  }
`

const RichEditor = forwardRef((props, ref) => (
  <EditorStyles>
    <Editor ref={ref} plugins={plugins} spellCheck="true" {...props} />
    <InlineToolbarWrapper>
      <InlineToolbar style={{top: '-50px'}}/>
    </InlineToolbarWrapper>
  </EditorStyles>
))

export default RichEditor
